import { InputBase } from '../../screens/SubmitCredentials/molecules/ProviderInputs/Input/TextField.styles';
import { styled } from '../../../core/theme/styled';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  border-radius: ${(props) => props.theme.roundedCorners.small};
  align-self: center;
`;

export const SingleInput = styled(InputBase)`
  border-radius: 0;
  text-align: center;
  font-size: ${(props) => props.theme.sizes.normedium};
  line-height: 28px;
  padding-top: ${(props) => props.theme.sizes.xsmall};
  padding-bottom: ${(props) => props.theme.sizes.xsmall};
  width: 45px;
  box-sizing: border-box;
  background-color: #fff;
  /* appearance is non-standard and needs manual prefixing. Needed to override default input styles in mobile browsers */
  /* stylelint-disable-next-line */
  -webkit-appearance: none;
  /* stylelint-disable-next-line */
  -moz-appearance: none;

  &:first-child {
    border-bottom-left-radius: ${(props) => props.theme.roundedCorners.small};
    border-top-left-radius: ${(props) => props.theme.roundedCorners.small};
  }
  &:last-child {
    border-top-right-radius: ${(props) => props.theme.roundedCorners.small};
    border-bottom-right-radius: ${(props) => props.theme.roundedCorners.small};
  }
  &:focus {
    outline: none;
  }

  @media ${(props) => props.theme.device.tablet} {
    text-align: center;
  }
`;
